import React, { useState, useRef, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TruncatedTextWithTooltip = ({
  text,
  maxWidth,
  className = "",
  placement = "top",
  id = "truncated-tooltip"
}) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const isTextOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsOverflowing(isTextOverflowing);
      }
    };

    checkOverflow();
    // Check again when text changes
    const timeoutId = setTimeout(checkOverflow, 100);

    return () => clearTimeout(timeoutId);
  }, [text]);

  const truncatedElement = (
    <div
      ref={textRef}
      className={`truncated-text ${className}`}
      style={{
        maxWidth: maxWidth || "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: isOverflowing ? "help" : "default"
      }}
    >
      {text}
    </div>
  );

  // Only show tooltip if text is actually truncated
  if (isOverflowing && text) {
    return (
      <OverlayTrigger
        placement={placement}
        overlay={
          <Tooltip id={`${id}-${Date.now()}`} className="truncated-tooltip">
            {text}
          </Tooltip>
        }
      >
        {truncatedElement}
      </OverlayTrigger>
    );
  }

  return truncatedElement;
};

export default TruncatedTextWithTooltip;